<template>
  <div class="center-warp">
    <div ref="inner" class="inner">
      <div class="case-header">
        <div class="case-header-left">
          <div class="case-header-btn">智贝云分析</div>
<!--          <div class="case-header-btn" @click="openOtherData">查看补充资料</div>-->
          <div class="case-header-btn" @click="showBriefDialog = true">查看对方资料</div>
        </div>
        <div class="case-header-right" v-if="member.member_type == 1" >
          <div class="case-header-btn" @click="writeSuggest">填写治疗建议</div>
          <div class="case-header-btn" @click="showResourceDialog = true">耗材商城</div>
          <div class="case-header-btn" @click="openMeetingDialog">创建会诊</div>
        </div>
      </div>
      <div class="case-content">
        <Card :id="caseId" :card_id="cardId" :caseDetailValue="caseDetailValue" @cardId="getCardId"/>
        <Detail :id="cardId" ref="detail"/>
        <Chat ref="chat" :card_id="cardId" :caseId="caseId"/>
      </div>
      <el-dialog
          :visible.sync="showResourceDialog"
          custom-class="take-dialog grey-bg"
          title="耗材商城"
          width="834px">
        <div class="icon-input">
          <div class="iconfont icon-sousuo"></div>
          <Input :placeholder="'搜索产品名称或产品编号'" v-model="queryParams.keyWords" @enter="getResource('new')"/>
<!--          <input placeholder="搜索产品名称或产品编号" v-model="queryParams.keyWords" @keydown.enter="getResource('new')" type="text">-->
        </div>
        <div class="resource-warp" @scroll="haocaiScroll">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <div v-for="item in list" class="resource-item">
            <img :src="item.main_pic">
            <div style="flex: 1">
              <div class="resource-info">
                <div class="limit-2">{{ item.name }}</div>
                <div class="limit-2">{{ item.desc }}</div>
              </div>
              <div class="add-btn" @click="handleDetail(item)">确定</div>
            </div>
          </div>
          <div v-if="loadStatus == 'over'" class="load-info">没有更多了~</div>
        </div>
      </el-dialog>
      <el-dialog
          :show-close="false"
          :visible.sync="showBriefDialog"
          custom-class="page-dialog"
          top="20vh"
          width="328px">
        <div class="brief-card" v-if="caseDetailValue.id">
          <img :src="member.member_type == 0 ?  require('@/assets/img/case_management/brief-bg-mentor.png'):  require('@/assets/img/case_management/brief-bg.png') "
               alt=""
               class="brief-card-bg">
          <template v-if="member.member_type == 0">
            <div class="brief-info">
              <img :src="caseDetailValue.mentor.head_pic" alt="">
              <div class="brief-info-name">
                <div>{{ caseDetailValue.mentor.real_name }}</div>
                <div>{{
                    caseDetailValue.mentor.city
                  }}·{{ caseDetailValue.mentor.province }}/{{ caseDetailValue.mentor.organization }}
                </div>
              </div>
            </div>
            <div class="brief-person-des">
              <img alt="" src="@/assets/img/case_management/brief-icon.png">
              <div>{{ caseDetailValue.mentor.introduction }}</div>
            </div>
          </template>
          <template v-else>
            <div class="brief-info">
              <img :src="caseDetailValue.doctor.head_pic" alt="">
              <div class="brief-info-name">
                <div>{{ caseDetailValue.doctor.real_name }}</div>
                <div>{{
                    caseDetailValue.doctor.city
                  }}·{{ caseDetailValue.doctor.province }}/{{ caseDetailValue.doctor.organization }}
                </div>
              </div>
            </div>
            <div class="brief-person-des">
              <img alt="" src="@/assets/img/case_management/brief-icon.png">
              <div>{{ caseDetailValue.doctor.introduction }}</div>
            </div>
          </template>
          <div class="brief-btn black-14" @click="showBriefDialog = false">确定</div>
        </div>
      </el-dialog>
      <el-dialog
          :close-on-click-modal="false"
          :show-close="false"
          :visible.sync="showCaseCardDetail"
          custom-class="page-dialog"
          width="834px">
        <div class="case-card-detail">
          <div class="case-card-detail-right">
            <div class="case-card-detailtitle d-flex-between">
              <div>其他资料</div>
              <div class="add-btn case-card-btn" @click="showCaseCardDetail = false">返回</div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充视频资料</div>
              <div class="case-upload-line">
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.media" >
                  <div v-for="item in otherCardData.other_media_json.media" class="upload-video-item">
                    <video controls :src="item.url" :poster="item.fm_img"></video>
                    <div>MP4</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">补充文件资料</div>
              <div class="case-upload-line">
                <template v-if="otherCardData.other_media_json && otherCardData.other_media_json.file" >
                  <div v-for="item in otherCardData.other_media_json.file" class="upload-file-item" @click="openUrl(item.url)">
                    <div class="upload-file-item-icon">
                      <img alt="" src="../../assets/img/case_management/upload-file.png">
                    </div>
                    <div class="upload-file-item-name limit-2">{{ item.title }}</div>
                  </div>
                </template>
              </div>
            </div>
            <div class="case-card-data-part">
              <div class="case-card-data-part-title">智贝云分析报告</div>
<!--              <div class="case-upload-line">-->
<!--                <div v-for="i in 2" class="upload-file-item">-->
<!--                  <div class="upload-file-item-icon">-->
<!--                    <img alt="" src="../../assets/img/case_management/upload-report.png">-->
<!--                  </div>-->
<!--                  <div class="upload-file-item-name limit-1">侧位片分析</div>-->
<!--                  <div class="upload-file-item-time">2023.09.26</div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </el-dialog>
      <ReceiveDialog ref="receiveDialog" :productId="product.id" :product="product" @chooseResource="getChooseResource" />
      <MeetingDialog ref="meetingDialog" :caseDetailValue="caseDetailValue"  />

    </div>
  </div>
</template>

<script>
import Card from "@/views/case_management/case_components/Card";
import Detail from "@/views/case_management/case_components/Detail";
import Chat from "@/views/case_management/case_components/Chat";
import ReceiveDialog from "@/views/consumables/components/ReceiveDialog";
import MeetingDialog from "@/views/consultation_room/components/MeetingDialog";
import {GetCaseInfo, GetOtherInfo} from "@/http/api";
import {search} from "@/http/product";

export default {
  components: {Card, Detail, Chat,ReceiveDialog,MeetingDialog},
  name: "index",
  data() {
    return {
      caseId: this.$route.query.case_id ? this.$route.query.case_id : 0,
      cardId: this.$route.query.card_id ? this.$route.query.card_id : 0,
      member: JSON.parse(localStorage.getItem('member')),
      showResourceDialog: false,
      showSuggestDialog: false,
      showBriefDialog: false,
      caseDetailValue: {},
      showCaseCardDetail:false,
      otherCardData:[],
      //耗材参数
      queryParams: {
        page: 1,
        pageSize: 10,
        category_id: 0,
        keyWords: undefined,
      },
      list:[], //耗材列表
      loadStatus:'',
      product:{},
    }
  },
  mounted() {
    var _that = this
    this.$nextTick(() => {
      GetCaseInfo({id: this.caseId}).then(res => {
        _that.caseDetailValue = res.data
        _that.$store.commit('caseDetailValueChange',res.data)
      })
      _that.$refs.detail.init(Number(_that.cardId))
      _that.getResource('new')
    })
  },
  methods: {
    getCardId(id) {
      let _that = this
      console.log(id)
      this.$nextTick(() => {
        _that.cardId = Number(id)
        _that.$refs.detail.init(Number(id))
      })
    },
    writeSuggest(){
      this.$refs.detail.openSuggest()
    },
    openOtherData(){
      this.initCardOtherData()
      this.showCaseCardDetail = true
    },
    initCardOtherData(){
      GetOtherInfo({card_id:this.cardId}).then(res=>{
        this.otherCardData = res.data
      })
    },
    haocaiScroll(e){
      var scrollTop = e.target.scrollTop
      var windowHeight = e.target.clientHeight
      var scrollHeight = e.target.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight - 20) {
        // 当前滚动条已经触底
        if(this.$store.state.workState) this.getResource()
      }
    },
    getResource(type){
      if(type == 'new') {
        this.queryParams.page = 1
        this.list = []
        this.loadStatus = 'load'
      }
      if(this.loadStatus == 'over') return false
      this.$store.commit('workStart')
      search(this.queryParams).then((res) => {
        let curData = res.data.data
        this.list = this.list.concat(curData)
        this.loadStatus = ''
        if(res.data.last_page == this.queryParams.page) this.loadStatus = 'over'
        else this.queryParams.page = res.data.last_page
        this.$store.commit('workOver')
      });
    },
    handleDetail(data){
      this.product = data
      this.$refs.receiveDialog.handleOpen('chat',this.caseDetailValue)
    },
    getChooseResource(data){
      let opt = {
        doctor_status: 0,
        id: data.id,
        mentor_status: data.mentor_status,
        order_status: data.order_status,
        patient_id: data.patient_id,
        process_status: data.process_status,
        product_category_name: data.product_category_name,
        product_code: data.product_code,
        product_desc: data.product_desc,
        product_id: data.product_id,
        product_is_dz: data.product_is_dz,
        product_name: data.product_name,
        product_pic: data.product_pic,
        product_quantity: data.product_quantity
      }
      this.showResourceDialog = false
      this.$refs.chat.sendMsg('order',opt)
    },
    openMeetingDialog(){
      this.$refs.meetingDialog.openCreateMeeting()
    },
    openUrl(url){
      window.open(url,'_blank')
    }
  }
}
</script>

<style scoped src="../../assets/css/case.css">
</style>
<style scoped src="../../assets/css/doctor-detail.css">
</style>
<style>
.page-dialog, .page-dialog .el-dialog__header, .page-dialog .el-dialog__body {
  padding: 0;
  background: transparent;
  box-shadow: none;
}
</style>
